import { render, staticRenderFns } from "./VeterinaryPatientReminders.vue?vue&type=template&id=a044e4b8&scoped=true"
import script from "./VeterinaryPatientReminders.vue?vue&type=script&lang=js"
export * from "./VeterinaryPatientReminders.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryPatientReminders.vue?vue&type=style&index=0&id=a044e4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a044e4b8",
  null
  
)

export default component.exports